module.exports = __webpack_public_path__ + "static/media/GameofThronesWallpaper.a278cd23.jpg";